import React, { useState } from 'react';
import ApprovalTimeline from '../ApprovalTimeline';

function TicketDetailsPanel({ ticket, fieldValues }) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!ticket) return null;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleExpand();
    }
  };

  return (
    <div className={`ticket-details-panel ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div
        className="panel-header collapsible-header"
        onClick={toggleExpand}
        onKeyDown={handleKeyPress}
        tabIndex={0}
        role="button"
        aria-expanded={isExpanded}
        aria-label="Toggle ticket details"
      >
        <div className="header-left">
          <h2 className="panel-title">
            Ticket Details <span className="ticket-id-inline">{ticket.ticket_number || 'N/A'}</span>
          </h2>
        </div>
        <div className="header-right">
          <span className="created-at-label">Created At</span>
          <span className="created-at-value">{formatDate(ticket.created_at)}</span>
          <button
            className="collapse-toggle"
            aria-label={isExpanded ? 'Click to collapse' : 'Click to expand'}
            title={isExpanded ? 'Click to collapse' : 'Click to expand'}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`feather feather-chevron-down ${isExpanded ? 'expanded' : ''}`}
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="panel-content">
          {/* Horizontal 4-Column Grid Layout */}
          <div className="details-horizontal-grid">
            {/* Column 1: Requester Name */}
            <div className="detail-item">
              <label>Requester Name</label>
              <div className="detail-value">
                <div>{ticket.requester_name || 'N/A'}</div>
                {ticket.requester_email && (
                  <a href={`mailto:${ticket.requester_email}`} className="requester-email">
                    {ticket.requester_email}
                  </a>
                )}
              </div>
            </div>

            {/* Column 2: Category & Subcategory */}
            <div className="detail-item">
              <label>Category & Subcategory</label>
              <div className="detail-value">
                <div>{ticket.category_name || 'N/A'}</div>
                <div className="subcategory-text">{ticket.subcategory_name || 'N/A'}</div>
              </div>
            </div>

            {/* Column 3: Location */}
            <div className="detail-item">
              <label>Location</label>
              <div className="detail-value">{ticket.store_name || ticket.store_pc || 'N/A'}</div>
            </div>

            {/* Column 4: Description */}
            <div className="detail-item">
              <label>Description</label>
              <div className="detail-value description-compact">
                {ticket.description || 'No description provided'}
              </div>
            </div>
          </div>

          {/* Additional Fields Row - Full Width */}
          {fieldValues && Object.keys(fieldValues).length > 0 && (
            <div className="conditional-fields-section">
              <h3>Additional Fields</h3>
              <div className="conditional-fields-grid">
                {Object.entries(fieldValues).map(([key, value]) => (
                  <div key={key} className="detail-item">
                    <label>{key.replace(/^ITDR\s*/i, '').replace(/_/g, ' ')}</label>
                    <div className="detail-value">{Array.isArray(value) ? value.map(v => typeof v === 'object' && v !== null ? (v?.value ?? JSON.stringify(v)) : v).join(', ') : (typeof value === 'object' && value !== null ? (value?.value ?? JSON.stringify(value)) : value) || 'N/A'}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Approval Timeline Section */}
          {ticket.approval_flow && ticket.approval_flow.length > 0 && (
            <div className="approval-timeline-section">
              <h3>Approval Status</h3>
              <ApprovalTimeline flow={ticket.approval_flow} ticketStatus={ticket.status} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default TicketDetailsPanel;
